<form class="edit-modal kw-dialog" (ngSubmit)="submit()" name="itemInputForm" id="itemInputForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Edit {{"Product" | tenantWords}}</h2>
      <div class="modal-subtitle">{{this.subtitle}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faCubes" class="section-icon"></fa-icon>
        <h3>{{"Product" | tenantWords}}</h3>
      </div>
      <div class="section-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{"Product" | tenantWords}}</mat-label>
          <mat-select name="selectedProduct" [(ngModel)]="this.hud.itemId" (ngModelChange)="porductChange()">
            <mat-option *ngFor="let f of this.items" [value]="f.id">
              {{f.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{"Lot" | tenantWords}}</mat-label>
          <mat-select id="lotSelect" required [(ngModel)]="this.lotId" name="lotSelect"
            (ngModelChange)="lotSelectionChanged()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="this.searchLot" (ngModelChange)="filterLots()"
                placeholderLabel="Find lot." noEntriesFoundLabel="No lots found" name="lotSearch">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="this.filteredLotOptions.length === 0">
              {{this.lotSearchPrompt}}
            </mat-option>
            <mat-option *ngFor="let lot of this.filteredLotOptions" [value]="lot.id">
              {{lot.lotNumber}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <dl class="facts">
        <div><dt>Variety</dt><dd>{{this.hud.varietyName || '—'}}</dd></div>
        <div><dt>Package Type</dt><dd>{{this.hud.packageName || '—'}}</dd></div>
        <div><dt>Parent {{"Product" | tenantWords}}</dt><dd>{{this.hud.parentItem || '—'}}</dd></div>
        <div><dt>Description</dt><dd>{{this.hud.itemDescription || '—'}}</dd></div>
      </dl>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faSliders" class="section-icon"></fa-icon>
        <h3>Quantity &amp; Attributes</h3>
      </div>
      <div class="section-grid cols-3">
        <mat-form-field appearance="outline">
          <mat-label>Quantity</mat-label>
          <input [(ngModel)]="this.hud.quantity" matInput type="number" id="qtyInput" name="qtyInput">
          <button *ngIf="this.hud.quantity" matSuffix mat-icon-button aria-label="Clear" type="button"
            (click)="this.hud.quantity = null">
            <fa-icon [icon]="faXmark"></fa-icon>
          </button>
        </mat-form-field>

        <ng-container *ngFor="let field of this.hud.itemAttributeValues">
          <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.datatype == 'string'" appearance="outline">
            <mat-label>{{field.name}}</mat-label>
            <input [(ngModel)]="field.value" [required]="field.isRequired" matInput type="text"
              id="custField{{field.id}}" name="custField{{field.id}}">
            <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
              (click)="field.value = ''">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </mat-form-field>

          <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.datatype == 'number'" appearance="outline">
            <mat-label>{{field.name}}</mat-label>
            <input [(ngModel)]="field.value" [required]="field.isRequired" matInput type="number"
              id="custField{{field.id}}" name="custField{{field.id}}">
            <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
              (click)="ClearValue(field)">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </mat-form-field>

          <mat-form-field *ngIf="getOptionsLength(field) > 0" appearance="outline">
            <mat-label>{{getFieldName(field)}}</mat-label>
            <mat-select [required]="field.isRequired" name="fieldOptions{{field.id}}" [(ngModel)]="field.value"
              id="custField{{field.id}}">
              <mat-option *ngFor="let w of getFieldOptions(field)" [value]="w.value">
                {{w.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.hud.id" mat-stroked-button class="danger-btn" type="button" (click)="deleteProduct()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
